import { onDocumentLoaded } from '@theme/utilities';

const capitalizeElements = (selector) => {
  try {
    const elements = document.querySelectorAll(selector);

    if (elements.length === 0) {
      console.warn(`No se encontraron elementos con el selector: ${selector}`);
      return;
    }

    elements.forEach(element => {
      const text = element.textContent;
      const capitalizedText = text
        .toLowerCase()
        .split(' ')
        .map(word => {
          // Capitalize "pg" specifically to "PG"
          if (word === 'pg') {
            return 'PG';
          }
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
      
      element.textContent = capitalizedText;
    });
  } catch (error) {
    console.error(`Error al capitalizar los elementos con el selector "${selector}":`, error);
  }
};

const openFirstMenuElements = () => {
  const elementChildLists = document.querySelectorAll('.menu-drawer__menu--childlist');
  elementChildLists.forEach((element) => {
    const firstElement = element.querySelector('li:first-child');
    if (firstElement) {
      const firstDetail = firstElement.querySelector('details');
      if (firstDetail) {
        firstDetail.setAttribute('open', '');
      }
    }
  });
};

onDocumentLoaded(() => {
  capitalizeElements('.product-details h1');
  capitalizeElements('.h3 p');
  capitalizeElements('.card-gallery .contents p');
  //capitalizeElements('.product-card a.contents p');
});

window.addEventListener('load', () => {
  setTimeout(() => {
    openFirstMenuElements();
  }, 500);
});

const variantSwatchExpand = () => {
  const expanded = new Set();

  const optionKey = (fieldset) => fieldset.querySelector('legend')?.firstChild?.textContent?.trim() || '';

  const apply = () => {
    for (const fieldset of document.querySelectorAll('variant-picker .variant-option--swatches')) {
      const isOpen = expanded.has(optionKey(fieldset));
      fieldset.classList.toggle('is-expanded', isOpen);
      fieldset.querySelector('.variant-more')?.setAttribute('aria-expanded', String(isOpen));
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target instanceof Element && event.target.closest('.variant-more');
    if (!toggle) return;

    const fieldset = toggle.closest('.variant-option--swatches');
    if (!fieldset) return;

    const key = optionKey(fieldset);
    expanded.has(key) ? expanded.delete(key) : expanded.add(key);
    apply();
  });

  document.addEventListener('variant:update', () => {
    apply();
    setTimeout(apply, 150);
  });
};

variantSwatchExpand();